import { AVAILABLE_DRIVERS_CLASS, DataManagerComponent, DataManagerConfiguration, DataManagerResponse, EventManager } from '@proteo/core';
import 'zone.js';
import { Process } from '../models/process.model';
import { getCommonProcessId, getSharedConfig } from './portal-services';

export class ProcessService {
  constructor() {}

  /**
   *
   * @param product
   * @returns
   */
  async getProcess(product: string): Promise<Process> {
    const params: Record<string, string> = {
      product: product
    };

    await this.setAuth();

    try {
      return await DataManagerComponent.getInstance()
        .get('mobile-app/api-onboarding-bff/v0/process', null, params)
        .then((res: DataManagerResponse<Process>) => {
          return Process.create(res.data as any);
        });
    } catch (error) {
      if (sessionStorage.getItem('invitationId')) {
        EventManager.getInstance().publish('ERROR', { error: '8' });
      } else {
        EventManager.getInstance().publish('ERROR', { error: '2' });
      }
    }
  }

  /**
   *
   * @param level INFO or ERROR
   * @param description If no error, user step in Onfido process (WELCOME, DOCUMENT_CAPTURE_FRONT...) or SOLID/APPLICANTID
   * @param message Error type + error message thrown by Onfido or message info
   */
  async postProcessLog(name: string, stage: string, level: string, message = '', description = '', headers = {}): Promise<void> {
    const body: Record<string, string> = {
      processId: getCommonProcessId(),
      stage: stage,
      level: level,
      name: name,
      message: message,
      description: level === 'ERROR' && (description === '' || description === undefined) ? 'ERROR' : description,
      detail: navigator.userAgent || ''
    };

    await this.setAuth();

    try {
      DataManagerComponent.getInstance().post('mobile-app/api-onboarding-bff/v0/process/log', body, headers);
    } catch (error) {
      EventManager.getInstance().publish('ERROR', { error: '2' });
    }
  }

  private async setAuth(): Promise<void> {
    await this.setP4Driver();
    const sessionAuth = sessionStorage.getItem('identificationAuth');
    const auth = JSON.parse(sessionAuth);
    DataManagerComponent.getInstance().setAuthorization(auth);
  }

  /**
   * Set driver P4
   */
  private async setP4Driver(): Promise<void> {
    const config = getSharedConfig('LANDING');
    const dataManagerConf: DataManagerConfiguration = {
      driver: AVAILABLE_DRIVERS_CLASS['P4'],
      host: config.portalConfig.REST_CONFIG.HOST,
      baseUrl: config.portalConfig.REST_CONFIG.BASE_PATH
    };

    DataManagerComponent.initInstance(dataManagerConf);
  }
}
